import { render, staticRenderFns } from "./TheActivityBox.vue?vue&type=template&id=66485065&scoped=true"
import script from "./TheActivityBox.vue?vue&type=script&lang=js"
export * from "./TheActivityBox.vue?vue&type=script&lang=js"
import style0 from "./TheActivityBox.vue?vue&type=style&index=0&id=66485065&prod&lang=css"
import style1 from "./TheActivityBox.vue?vue&type=style&index=1&id=66485065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66485065",
  null
  
)

export default component.exports